export type ConfirmCodeStatus = 'default' | 'failed' | 'loading' | 'success';
export enum CodeStatus {
  default = 'default',
  success = 'success',
  failed = 'failed',
  loading = 'loading',
}
